import React from 'react';
import { pidOf } from '../../utils/normalizePlayerId';

function PlayerReadyList({ nonHostPlayers = [], readyPlayers = [] }) {
  return (
    <ul className="mt-1 ml-2 text-xs">
      {nonHostPlayers.map((p) => {
        const pid = pidOf(p);
        const isReady = pid ? readyPlayers.includes(pid) : false;
        return (
          <li key={pid} className={isReady ? 'text-green-600 dark:text-green-400' : 'text-gray-500 dark:text-gray-400'}>
            {isReady ? '✔️' : '❌'} {p.username}
          </li>
        );
      })}
    </ul>
  );
}

export default PlayerReadyList;
